import React, { Component, Suspense } from "react";
import axios from "axios";
import NumberFormat from 'react-number-format';
import { Link } from "react-router-dom";
import "./Tree.scss";
import ProgramTree from "../Program/ProgramTree";
import { ToastContainer, toast } from "react-toastify";
import IconJejakin from './../../../images/icon-jejakin.png';
import Jaki from './../../../images/jaki-cat.png';
import { DebounceInput } from "react-debounce-input";
import Select from "react-select";
import ContentLoader from "react-content-loader";
import InfiniteScroll from "react-infinite-scroll-component";
import { Translation } from "react-i18next";

const CardLoader = () => (
   <ContentLoader height={320}>
      <rect x="0" y="0" rx="6" ry="6" width="100%" height="220" />
      <rect x="0" y="230" rx="6" ry="6" width="300" height="12" />
      <rect x="0" y="250" rx="6" ry="6" width="300" height="16" />
      <rect x="0" y="275" rx="6" ry="6" width="50" height="12" />
   </ContentLoader>
);

const selectStyles = {
   container: (base, state) => ({
      ...base,
      opacity: state.isDisabled ? ".5" : "1",
      backgroundColor: "transparent",
      zIndex: "995",
   }),
};

class Tree extends Component {
   state = {
      status: true,
      statusLogin: false,
      statusUser: false,
      isVerified: false,
      verify: false,
      userFootprint: false,
      total_carbon : 0,
      error: null,
      loaderVerify: false,
      loading: true,
      programs: [],
      hasMore: false,
      sellers: [],
      provinces: [],
      program_pagination: {
         page: 1, // Default Page
         limit: 8, // Default Limit
      },
      pagination: [],
      search_form: {},
      inputSearch: "",
      selectedOptionProvince: null,
      selectedOptionSeller: null,
   };

   verifyAccount = (token) => {
      this.setState({ loaderVerify: true });
      axios({
         method: "POST",
         url: process.env.REACT_APP_API_HOST + "/user/verify/" + token,
      }).then((response) => {
         // console.log("reponse data verify ", response.data);
         if (response.data.status === true) {
            this.setState({ verify: true });
         } else {
            setTimeout(() => {
               this.setState({ loaderVerify: false });
            }, 3000);
            if (response.data.error.length) {
               for (var er = 0; er < response.data.error.length; er++) {
                  var obj = response.data.error[er];
                  if (response.data.error[er].id === "UserMustNotVerified") {
                     this.setState({ isVerified: true });
                     toast.success(response.data.error);
                  } else {
                     for (var key in obj) {
                        console.log(key, obj[key]);
                        toast.error(key + " : " + obj[key]);
                     }
                  }
               }
            } else {
               toast.error(response.data.error);
            }
         }
      });
   };

   get_program_list = () => {
      var selectedProvince = "All";
      var selectedSeller = "All";
      // console.log("selectedOptionSeller is ", this.state.selectedOptionSeller);
      if (this.state.selectedOptionProvince !== null) {
         selectedProvince = this.state.selectedOptionProvince.province;
      }
      if (this.state.selectedOptionSeller !== null) {
         selectedSeller = this.state.selectedOptionSeller.corporateId;
      }
      axios
         .get(
            process.env.REACT_APP_API_HOST +
            "/program/list/tree?province=" +
            selectedProvince +
            "&corporateId=" +
            selectedSeller +
            "&page=" +
            this.state.program_pagination.page +
            "&limit=8"
         )
         .then((res) => {
            // console.log("res data ", res.data);
            if (res.data.status === true) {
               setTimeout(() => {
                  var programsNew = this.state.programs;
                  res.data.programs.map((listprogram) => {
                     programsNew.push(listprogram);
                  });
                  if (
                     this.state.program_pagination.page <
                     res.data.pagination.pageCount + 1
                  ) {
                     this.setState({
                        programs: programsNew,
                        sellers: res.data.sellers,
                        provinces: res.data.provinces,
                        hasMore: true,
                        program_pagination: { page: res.data.pagination.page + 1 },
                        loading: false,
                     });
                  } else {
                     this.setState({
                        programs: programsNew,
                        sellers: res.data.sellers,
                        provinces: res.data.provinces,
                        hasMore: false,
                        loading: false,
                     });
                  }
               }, 1000);
            } else {
               this.setState({
                  status: false,
                  error: res.data.error,
                  loading: false,
                  hasMore: false,
               });
            }
         });
   };

   componentDidMount() {
      const query = new URLSearchParams(this.props.location.search);
      const verify = query.get("verify");
      const tokenVerify = new String(verify);
      const total_carbon = query.get("total_carbon");
      // console.log('totalcarbon is ', total_carbon)
      if (total_carbon) {
         this.setState({ userFootprint: true, total_carbon: total_carbon, lang: window.localStorage.i18nextLng  });
      } else {
         this.setState({ userFootprint: false, total_carbon: 0, lang: window.localStorage.i18nextLng  });
      }
      if (verify && tokenVerify.length > 200) {
         console.log("Verification..");
         this.verifyAccount(tokenVerify);
      }
      const userData = localStorage.getItem("userData");
      let statusLogin;
      if (userData) {
         statusLogin = true;
         this.setState({ statusUser: true });
      } else {
         statusLogin = false;
         this.setState({ statusUser: false });
      }
      // console.log("userData is ", userData);
      this.get_program_list();
   }

   handleSelectProvince = (selectedOptionProvince) => {
      this.setState(
         {
            selectedOptionProvince,
            loading: true,
            programs: [],
            program_pagination: {
               page: 1,
               limit: 8,
            },
         },
         () => this.get_program_list()
      );
      // console.log(`Option selected:`, selectedOptionProvince);
   };

   handleSelectSeller = (selectedOptionSeller) => {
      // console.log("selected option sellers ", selectedOptionSeller);
      this.setState(
         {
            selectedOptionSeller,
            loading: true,
            programs: [],
            program_pagination: {
               page: 1,
               limit: 8,
            },
         },
         () => this.get_program_list()
      );
      // console.log(`Option selected:`, selectedOptionSeller);
   };

   render() {
      return (
         <div className="mpl-page cp-85">
            <ToastContainer />
            <Suspense fallback={"...Loading"}>
               <Translation>
                  {(t) => (
                     <div className="container">
                        <div className="row">
                           <div className="col-12">
                              {this.state.loaderVerify ? (
                                 <div>
                                    {this.state.verify === true ? (
                                       <div className="wrapper-banner text-center box-verify success">
                                          <i className="fa fa-check"></i>
                                          <br />
                                          <span>Akun telah terverifikasi</span>
                                          <br />
                                          <div className="form-group mt-2 mb-0">
                                             <Link
                                                to="/login"
                                                className="btn btn-outline-green"
                                             >
                                                MASUK
                              </Link>
                                          </div>
                                       </div>
                                    ) : (
                                       <div className="box-verify text-center mb-4">
                                          <span>
                                             <div
                                                className="loader"
                                                style={{
                                                   borderColor: "#00880d",
                                                   borderTopColor: "#ddd",
                                                   margin: "auto",
                                                }}
                                             ></div>
                                             <br />
                                             <br />
                                             <small>Memverifikasi akun..</small>
                                          </span>
                                          <br />
                                       </div>
                                    )}
                                 </div>
                              ) : null}

                              {
                                 this.state.userFootprint ? (
                                    <>
                                       <div className="box-calc-emission" style={{marginBottom:'25px'}}>
                                          <span>{t('YourTotalCarbonFootprint')}</span>
                                          <img src={Jaki} alt="Jejakin" />
                                          <h2 className="mb-0">
                                             {
                                                this.state.lang === 'id' ? (
                                                   <React.Fragment>
                                                      <NumberFormat value={parseFloat(this.state.total_carbon)} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} decimalScale={0} /> gram
                                                   </React.Fragment>
                                                ) : (
                                                   <React.Fragment>
                                                      <NumberFormat value={parseFloat(this.state.total_carbon)} displayType={'text'} thousandSeparator={','} decimalSeparator={'.'} decimalScale={0} /> grams
                                                   </React.Fragment>
                                                )
                                             }
                                          </h2>
                                       </div>
                                    </>
                                 ) : null
                              }
                              
                              <div className="wrapper-filter">
                                 <div className="row">
                                    <div className="col-auto">
                                       <div style={{ width: "175px", zIndex: 20 }}>
                                          <h4 className="mt-0 mb-2">{t("tree.lokasi")}</h4>
                                          <Select
                                             styles={selectStyles}
                                             className="react-select-container"
                                             classNamePrefix="react-select"
                                             defaultValue={{ value: "", province: t("all") }}
                                             onChange={this.handleSelectProvince}
                                             getOptionLabel={(option) => `${option.province}`}
                                             getOptionValue={(option) => `${option.province}`}
                                             options={this.state.provinces}
                                             isSearchable={true}
                                             isClearable={true}
                                          />
                                       </div>
                                    </div>
                                    {/* <div className="col-auto">
                                       <div style={{ width: "175px", zIndex: 20 }}>
                                          <h4 className="mt-0 mb-2">{t("tree.penjual")}</h4>
                                          <Select
                                             styles={selectStyles}
                                             className="react-select-container"
                                             classNamePrefix="react-select"
                                             defaultValue={{
                                                value: "",
                                                corporateName: t("all"),
                                             }}
                                             onChange={this.handleSelectSeller}
                                             getOptionLabel={(option) =>
                                                `${option.corporateName}`
                                             }
                                             getOptionValue={(option) =>
                                                `${option.corporateId}`
                                             }
                                             options={this.state.sellers}
                                             isSearchable={true}
                                             isClearable={true}
                                          />
                                       </div>
                                    </div> */}
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  )}
               </Translation>
            </Suspense>

            {this.state.loading === true ? (
               <div className="container">
                  <div className="row">
                     <div className="col-sm-6">
                        <CardLoader />
                     </div>
                     <div className="col-sm-6">
                        <CardLoader />
                     </div>
                     <div className="col-sm-6">
                        <CardLoader />
                     </div>
                     <div className="col-sm-6">
                        <CardLoader />
                     </div>
                     <div className="col-sm-6">
                        <CardLoader />
                     </div>
                     <div className="col-sm-6">
                        <CardLoader />
                     </div>
                     <div className="col-sm-6">
                        <CardLoader />
                     </div>
                     <div className="col-sm-6">
                        <CardLoader />
                     </div>
                  </div>
               </div>
            ) : (
               <React.Fragment>
                  {this.state.programs.length === 0 ? (
                     <div className="container">
                        <div className="row">
                           <div className="col-sm-12">
                              <div className="text-center" style={{ height: "100px" }}>
                                 <small>Program not found</small>
                              </div>
                           </div>
                        </div>
                     </div>
                  ) : (
                     <React.Fragment>
                        {this.state.programs.length === 0 ? (
                           <div className="container">
                              <div className="row">
                                 <div className="col-sm-12">
                                    <div
                                       className="text-center"
                                       style={{ height: "100px" }}
                                    >
                                       <small>Program not found</small>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        ) : (
                           <React.Fragment>
                              <InfiniteScroll
                                 dataLength={this.state.programs.length}
                                 pageStart={1}
                                 next={this.get_program_list}
                                 hasMore={this.state.hasMore}
                                 loader={
                                    <div
                                       className="text-center"
                                       style={{ marginTop: "40px" }}
                                    >
                                       <div
                                          className="loader"
                                          style={{
                                             height: "24px",
                                             width: "24px",
                                             borderColor: "#00880d",
                                             borderTopColor: "#ddd",
                                             margin: "auto",
                                          }}
                                       ></div>
                                    </div>
                                 }
                              >
                                 <div className="container">
                                    <div className="row">
                                       {this.state.programs.map((program) => {
                                          return (
                                             <ProgramTree
                                                key={program.id}
                                                id={program.id}
                                                title={program.title}
                                                urlFeaturedImage={program.urlFeaturedImage}
                                                corporateName={program.corporateName}
                                                province={program.province}
                                                city={program.city}
                                                minPrice={program.minPrice}
                                                maxPrice={program.maxPrice}
                                                priceRange={program.priceRange}
                                                currencySymbol={program.currencySymbol}
                                                params_url={window.location.href.split('?')[1]}
                                             />
                                          );
                                       })}
                                    </div>
                                 </div>
                              </InfiniteScroll>
                           </React.Fragment>
                        )}
                     </React.Fragment>
                  )}
               </React.Fragment>
            )}
         </div>
      );
   }
}

export default Tree;
